/* tslint:disable */
export var icon = "\n<svg width=\"10\" height=\"8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1 3l3 3 5-5\" stroke=\"#3899EC\" stroke-width=\"2\"/></svg>\n";
//# sourceMappingURL=check-inline.svg.js.map